<template>
  <fragment>
    <template v-for="item in routerList">
      <el-submenu
        v-if="item.hasOwnProperty('subs') && item.subs.length > 0"
        :key="item.index"
        :index="item.index"
        :route="item.index"
      >
        <template slot="title" style="padding-left: 10px">
          <i :class="item.icon"></i>
          <span slot="title">{{ item.title }}</span>
        </template>
        <!--  如果有子级数据使用递归组件 -->
        <Menu :routerList="item.subs"></Menu>
      </el-submenu>
      <el-menu-item v-else :index="item.index" :key="item.index">
        <i :class="item.icon"></i>
        <span>{{ item.title }}</span>
      </el-menu-item>
    </template>
  </fragment>
</template>

<script>
export default {
  props: ['routerList'],
  name: 'Menu', //模板名称
  created() {},
};
</script>
<style lang="less" scoped>
.el-menu--collapse span,
.el-menu--collapse i.el-submenu__icon-arrow {
  height: 0;
  width: 0;
  overflow: hidden;
  visibility: hidden;
  display: inline-block;
}
</style>
